import React from "react";
import DataTable from "../../../components/ui/DataTable";
import BatchStatusBadge from "./BatchStatusBadge";
import BatchProgressBar from "./BatchProgressBar";
import BatchRowActions from "./BatchRowActions";
import BatchCard from "./BatchCard";

/**
 * Batches table matching the wireframe: header row, progress bars, status
 * badges and per-row actions. Thin wrapper around the shared `DataTable`
 * (desktop table + mobile card fallback) — see `DataTable` for the actual
 * markup/responsive behaviour.
 */
const BatchTable = ({ rows, isLoading, noDataLabel = "No batches found", onRowAction }) => {
  const columns = [
    { key: "batchId", header: "Batch ID", render: (row) => <span className="font-medium text-slate-900">{row.batchId}</span> },
    { key: "partId", header: "Part ID", render: (row) => row.partLabel },
    { key: "qty", header: "Qty", render: (row) => row.quantity ?? "-" },
    { key: "progress", header: "Progress", render: (row) => <BatchProgressBar progress={row.progress} status={row.status} /> },
    { key: "status", header: "Status", render: (row) => <BatchStatusBadge status={row.status} /> },
    { key: "createdOn", header: "Created On", render: (row) => row.createdOnLabel },
    {
      key: "action",
      header: "Action",
      render: (row) => (
        <BatchRowActions
          downloadDisabled={!row.canDownloadSlip}
          onDownload={() => onRowAction("download", row)}
          onView={() => onRowAction("view", row)}
          onEdit={row.canEdit ? () => onRowAction("edit", row) : undefined}
          onDispatch={row.canDispatch ? () => onRowAction("dispatch", row) : undefined}
          onDelete={() => onRowAction("delete", row)}
        />
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={rows}
      isLoading={isLoading}
      loadingLabel="Loading batches…"
      noDataLabel={noDataLabel}
      onRowClick={(row) => onRowAction("view", row)}
      renderCard={(row) => (
        <BatchCard
          batch={row}
          downloadDisabled={!row.canDownloadSlip}
          onDownload={() => onRowAction("download", row)}
          onView={() => onRowAction("view", row)}
          onEdit={row.canEdit ? () => onRowAction("edit", row) : undefined}
          onDispatch={row.canDispatch ? () => onRowAction("dispatch", row) : undefined}
          onDelete={() => onRowAction("delete", row)}
        />
      )}
    />
  );
};

export default BatchTable;
